export default "/wp-content/plugins/career-map-plugin/public/assets/images/illustration_save-career-path.svg";